import React, { Children } from 'react';
import TablePagination from './TablePagination';

const TableWrapServerSide = ({ tableColumnList, totalDataCount, initialPage, onChangePage, per_page, children }) => {
    return (
        <div className="db-table-main">
            <div className="db-table-responsive">
                <table className="db-table stripe">
                    <thead className="db-table-head">
                        <tr className="db-table-head-tr">
                            {tableColumnList.length > 0 &&
                                tableColumnList.map((data) => (
                                    <th key={data.name} className={`db-table-head-th ${!data.isIncludePrint ? 'hidden-print hidden-print-remove' : ''}`}>
                                        {data.name}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody className="db-table-body">{children}</tbody>
                </table>
            </div>
            <TablePagination items={totalDataCount} initialPage={initialPage} onChangePage={onChangePage} per_page={per_page} />
        </div>
    );
};

export default TableWrapServerSide;
